import { css } from 'lit';

export const style = css`
	* {
		box-sizing: border-box;
	}

	:host {
		font-size: var(--og-font-size);
		display: flex;
		flex-direction: column;
		height: 100%;
	}

	.controls {
		flex: 0;
		display: flex;
		flex-direction: row;
		gap: 4px;
		padding: 2px;
	}

	.controls > * {
		flex: 1;
		text-align: center
	}

	.switch {
		display: flex; 
		align-items: 
		center; gap: 4px; 
		flex-direction: row;
	}

	.body {
		flex: 1;
		overflow: hidden;
	}

	og-list {
		height: 100%;
	}
`;

export const itemStyle = css`
	.item {
		padding: 4px;
		border-top: 1px solid var(--og-accent-color);
	}

	.header {
		display: flex;
		gap: 4px;
		flex-direction: row;
		line-height: 22px;
		max-height: 22px;
	}
	
	.header div:first-child {
		background-color: var(--og-accent-color);
		color: var(--og-colortype-accent-text-color);
		padding: 0 2px;
	}

	.header div:nth-child(2) {
		flex: 1;
	}

	.header og-dropdown-list, .header og-dropdown-menu {
		height: 100%;
		border-color: var(--og-accent-color);
	}

	.header og-dropdown-menu {
		width: 20px;
	}

`;